// 塞尔维亚语
export const GUIDES = [
  { name: 'guide-overview', title: 'Pregled funkcija', groupIndex: 0 },
  { name: 'guide-account', title: 'O nalogu', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'O vozilu', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Kako podesiti kontrolnu tablu', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Kako postaviti vozilo', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Kako se kretati da biste pronašli vozilo', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Kako koristiti navigaciju', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'O istoriji vožnje', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Kako izvršiti samopregled vozila', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Kako napraviti opće postavke APP-a', groupIndex: 3 },
  { name: 'guide-notice', title: 'Kako pregledati i postaviti obavijest o poruci', groupIndex: 3 },
  { name: 'guide-about', title: 'O APP-u', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'нерешен',
  1: 'Bez odgovora',
  2: 'Odgovor',
  3: 'у комуникацији',
  4: 'противмере',
  5: 'решено',
};

export const FEEDBACK_TYPES = {
  1: 'Vraćanje',
  2: 'Odgovori',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
